(function () {
  if (window.__showroomSpotLayerReady) return;
  window.__showroomSpotLayerReady = true;

  var CLOSE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path fill="#d95033" d="M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z"/></svg>';

  function styleHotspotCards() {
    document.querySelectorAll(".showroom-spot-layer .pointBoxArrow svg path").forEach(function (path) {
      path.setAttribute("fill", "#f0e5d5");
    });
    document.querySelectorAll(".showroom-spot-layer .pointBoxCloseIcon").forEach(function (icon) {
      if (icon.querySelector("svg[data-showroom-close]")) return;
      icon.style.backgroundColor = "#f0e5d5";
      icon.innerHTML = CLOSE_SVG.replace("<svg ", '<svg data-showroom-close="1" ');
    });
  }

  function staggerPulse() {
    document.querySelectorAll(".showroom-spot-layer").forEach(function (layer) {
      layer.querySelectorAll(".iactiveImgPoint").forEach(function (pin, i) {
        var delay = (i % 8) * 0.38 + "s";
        if (pin.style.animationDelay !== delay) pin.style.animationDelay = delay;
      });
    });
  }

  function hasOpenHotspotCard() {
    return Array.prototype.some.call(document.querySelectorAll(".showroom-spot-layer .pointBox"), function (box) {
      var display = box.style.display || "";
      var visibility = box.style.visibility || "";
      return display === "block" && visibility !== "hidden";
    });
  }

  function restoreSplideFromHotspot() {
    var popupOpen = hasOpenHotspotCard();

    document.querySelectorAll(".splide--product").forEach(function (root) {
      [root, root.querySelector(".splide__track"), root.querySelector(".splide__list")].forEach(function (el) {
        if (!el) return;
        if (!popupOpen) {
          var overflow = el.style.overflow || el.style.overflowX || el.style.overflowY;
          if (overflow && overflow !== "hidden") {
            el.style.removeProperty("overflow");
            el.style.removeProperty("overflow-x");
            el.style.removeProperty("overflow-y");
          }
        }
        el.style.removeProperty("clip-path");
        el.style.removeProperty("contain");
      });

      var list = root.querySelector(".splide__list");
      if (list) {
        if (list.style.transform === "none") list.style.removeProperty("transform");
        if (list.style.transition === "none") list.style.removeProperty("transition");
        list.style.removeProperty("animation");
        list.style.removeProperty("filter");
        list.style.removeProperty("opacity");
        list.style.removeProperty("will-change");
      }

      root.querySelectorAll(".splide__slide").forEach(function (slide) {
        if (popupOpen && !slide.classList.contains("is-active")) {
          slide.style.visibility = "hidden";
        } else if (slide.style.visibility === "hidden") {
          slide.style.removeProperty("visibility");
        }
      });
    });
  }

  function afterPinInteraction() {
    restoreSplideFromHotspot();
    styleHotspotCards();
    staggerPulse();
  }

  function bootHotspotApp() {
    if (typeof window.initIImg === "function") {
      window.initIImg();
    }
    afterPinInteraction();
  }

  document.addEventListener(
    "click",
    function (event) {
      if (!event.target || !event.target.closest) return;
      if (!event.target.closest(".iactiveImgPoint, .iactiveImgHit, .pointBox")) return;
      afterPinInteraction();
      window.requestAnimationFrame(afterPinInteraction);
      window.setTimeout(afterPinInteraction, 0);
      window.setTimeout(afterPinInteraction, 50);
    },
    true
  );

  if (typeof MutationObserver === "function") {
    var observer = new MutationObserver(function () {
      restoreSplideFromHotspot();
      styleHotspotCards();
      staggerPulse();
    });
    function watchTracks() {
      document.querySelectorAll(".splide--product .splide__track, .splide--product .splide__list").forEach(function (el) {
        observer.observe(el, { attributes: true, attributeFilter: ["style"] });
      });
      document.querySelectorAll(".showroom-spot-layer").forEach(function (el) {
        observer.observe(el, { childList: true, subtree: true });
      });
    }
    watchTracks();
    window.setTimeout(watchTracks, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootHotspotApp);
  } else {
    bootHotspotApp();
  }

  window.addEventListener("load", bootHotspotApp);
  document.addEventListener("shopify:section:load", bootHotspotApp);
})();
